import { renderIsomorphicComponent, renderComponent } from "@quintype/framework/client/start";
import get from "lodash/get";

import { pickComponent } from "../isomorphic/pick-component";
import LoadingIndicatorComponent from "../isomorphic/components/atoms/loading-indicator";
import BreakingNewsSliderView from "../isomorphic/components/BreakingNewsSlider";

import TopAd from "../isomorphic/components/molecules/TopAd";
import { pickFooter } from "../isomorphic/pick-footer";
import UniformHeader from "../isomorphic/components/layouts/header/UniformHeader";
import InterstitialAd from "../isomorphic/components/molecules/InterstitialAd";
import InterstitialAdFormatTwo from "../isomorphic/components/molecules/InterstitialAdFormatTwo";
import AdAsia from "../isomorphic/components/molecules/AdAsia";
import GdprPolicy from "../isomorphic/components/molecules/GdprPolicy";

export function preRenderApplication(store) {
  const hydrate = { hydrate: !global.qtLoadedFromShell };
  const pageType = get(store.getState(), ["qt", "pageType"], null);
  pageType !== "sign-in-page" &&
    pageType !== "sign-up-page" &&
    pageType !== "forgot-password-page" &&
    renderComponent(UniformHeader, "header", store, hydrate);
  renderComponent(LoadingIndicatorComponent, "loading-indicator", store);
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  const domainSlug = get(store.getState(), ["qt", "config", "domainSlug"], null);
  const hydrate = { hydrate: !global.qtLoadedFromShell };
  renderComponent(TopAd, "top-ad", store, hydrate);
  renderComponent(InterstitialAd, "interstitial-ad", store, hydrate);
  renderComponent(InterstitialAdFormatTwo, "interstitial-ad-format-two", store, hydrate);
  if (!window.location.host.includes("auth")) {
    renderComponent(AdAsia, "ad-asia", store, hydrate);
  }
  pickFooter().then((footer) => renderComponent(footer.default, "footer", store));
  if (domainSlug !== "trust") {
    renderComponent(BreakingNewsSliderView, "breaking-news-container", store, hydrate);
  }
  renderComponent(GdprPolicy, "gdpr-policy", store, hydrate);
  renderIsomorphicComponent("container", store, pickComponent, {
    hydrate: !global.qtLoadedFromShell,
  });
}
